const NYLAS_AUTH_URL = "https://api.nylas.com/oauth/authorize";
const NYLAS_CLIENT_ID = process.env.REACT_APP_NYLAS_CLIENT_ID;
// const NYLAS_CLIENT_SECRET = process.env.REACT_APP_NYLAS_CLIENT_SECRET;
// const REDIRECT_HOST = process.env.REACT_APP_OUTLOOK_REDIRECTURI;

export { NYLAS_AUTH_URL, NYLAS_CLIENT_ID };
